import { CSSProperties } from 'react';

import clsx from 'clsx';

import { createPolymorphicComponent } from '~/helpers/typescript-helpers';

import styles from './text.module.css';

export type TextVariants =
	| 'display1'
	| 'display2'
	| 'display3'
	| 'display3Push'
	| 'display4'
	| 'display5'
	| 'body'
	| 'bodyBold'
	| 'bodySm'
	| 'bodySmBold'
	| 'bodyXs'
	| 'bodyXsBold'
	| 'caption'
	| 'label'
	| 'suggestion';

export type TextProps = {
	variant?: TextVariants;
	marginBottom?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10';
	marginTop?: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10';
	alignment?: CSSProperties['textAlign'];
};

/**
 * Override rendered markup with `as` attribute. For instance:
 *
 * ```tsx
 * <Text as="span">An span in markup.</Text>
 * ```
 */
export const Text = createPolymorphicComponent<'p', TextProps>(({ as: ComponentType = 'p', className, alignment, marginBottom, marginTop, variant, style, ...rest }, ref) => (
	<ComponentType
		className={clsx('text', styles[variant || 'noVariant'], className)}
		style={{
			textAlign: alignment,
			marginBottom: marginBottom && `var(--spacing-0${marginBottom})`,
			marginTop: marginTop && `var(--spacing-0${marginTop})`,
			...style,
		}}
		{...rest}
		ref={ref}
	/>
));
